import Header from './Header'
import Footer from './Footer'
import { useContext } from 'react'
import AppContext from '../services/context'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const PageTemplate = ({ children, showSearchInput, alwaysShowLogo }) => {

  const { loading, searchResults, individualResult, themeKey } = useContext(AppContext)
  const isDarkTheme = themeKey === 'dark'
  const headerWithLogo = alwaysShowLogo
    ? true
    : Boolean(!searchResults.length && !individualResult.title && !loading)

  return (
    <div className="min-h-screen flex flex-col">
      {loading && (
        <div className={clsx(
          "loading-bar",
          isDarkTheme ? "bg-greenbook-dark-loading" : "bg-greenbook-light-loading"
        )}></div>
      )}
      <Header withLogo={headerWithLogo} showSearchInput={showSearchInput} />
      <main className="flex-grow">
        {children}
      </main>
      <Footer withLogo={Boolean(searchResults.length || individualResult.title)} />
    </div>
  );
};

PageTemplate.propTypes = {
  children: PropTypes.node,
  showSearchInput: PropTypes.bool,
  alwaysShowLogo: PropTypes.bool,
};

PageTemplate.defaultProps = {
  showSearchInput: true,
  alwaysShowLogo: false,
};

export default PageTemplate;
